<template>
  <div class="toast-container">
    <!-- dialog 无法支持 v-show，只能使用 v-if 进行显示切换 -->
    <!--    todo 自定义toast-->
    <!--    <v-modal :name="modalKey"-->
    <!--             width="60%" height="auto" :maxWidth="320" :style="styles.container" :clickToClose="maskClosable"-->
    <!--             classes="v-toast-container">-->
    <!--      <div :style="styles.bodyContainer"-->
    <!--           @click="stopPropagation" >-->
    <!--        <slot name="content">-->
    <!--          <div v-if="$slots.content || content"-->
    <!--               :style="styles.contentContainer">-->
    <!--            <hy-text size="m"-->
    <!--                     color="#fff" :customStyle="{ textAlign: 'center' }">{{content}}</hy-text>-->
    <!--          </div>-->
    <!--        </slot>-->
    <!--      </div>-->
    <!--    </v-modal>-->
  </div>
</template>

<script>
import StyleSheet from '../StyleSheet';

const styles = StyleSheet.create({
  container: {
    borderRadius: 2,
  },
  bodyContainer: {
    backgroundColor: 'rgba(0,0,0,0.6)',
    maxWidth: 320,
    borderRadius: 4,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    alignItems: '',
    paddingTop: 12,
    paddingBottom: 12,
    paddingLeft: 12,
    paddingRight: 12,
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 56,
  },
  contentContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    display: 'flex',
  },
  body: {
    // minHeight: 120,
    paddingTop: 10,
    paddingBottom: 12,
    paddingLeft: 20,
    paddingRight: 20,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  actionBar: {
    height: 50,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});
export default {
  name: 'HyToast',
  // model: {
  //  prop: 'show',
  //  event: 'change'
  // },
  props: {
    // show: {
    //  type: Boolean,
    //  default: false,
    // },
    maskClosable: { // 点击蒙层是否触发关闭
      type: Boolean,
      default: true,
    },
    content: {
      type: String,
      default: '',
    },
    duration: {
      type: Number,
      default: 2000,
    },
  },
  data() {
    return {
      styles,
      modalKey: `hy-toast-${Math.random()}`,
    };
  },
  mounted() {
  },
  methods: {
    stopPropagation(evt) {
      evt.stopPropagation();
    },
    close() {
      if (this.$modal) {
        this.timer && clearTimeout(this.timer);
        this.$modal.hide(this.modalKey);
        this.$emit('change', false);
      }
    },
    open() {
      if (this.$modal) {
        this.timer && clearTimeout(this.timer);
        this.$modal.show(this.modalKey);
        this.$emit('change', true);
        // this.timer = setTimeout(() => {
        //  this.close();
        //  this.$emit('change', false);
        // }, duration || this.duration);
      }
    },
  },
};
</script>

<style>
.v-toast-container {
 border-radius: 10px;
 overflow: hidden;
 padding: 0px;
 margin: 0px;
}
.toast-container .v--modal-overlay {
  background: transparent;
}
</style>
